export const CONTACT = {
  phone: "+91 98399 11145",
  tel: "+919839911145",
  phone2: "+91 98399 11144",
  tel2: "+919839911144",
  email: "tideinc@gmail.com",
  address: "66-A, Coop. Ind. Estate, Dada Nagar, Kanpur (U.P.), India 208022",
};

export const PRODUCT_ORDER = [
  "food-grade-fibc-ink", "heat-resistant-cement-bag-ink", "tape-tested-fertilizer-bag-ink", "woven-sack-ink",
  "non-woven-fabric-ink", "reverse-lamination-ink", "extrusion-lamination-ink", "gravure-ink", "poly-ink",
  "ink-reducer", "metallic-ink", "foil-ink",
];

export const CATEGORIES = ["All", "Specialty Packaging", "Lamination", "Surface Printing", "Auxiliaries"];

const RAW_PRODUCTS = [
  {
    slug: "non-woven-fabric-ink",
    name: "Non Woven Fabric Inks",
    short: "Non Woven Fabric Ink",
    category: "Surface Printing",
    swatch: "#FF8A00",
    image: "/img/new-nonwoven.jpg",
    tagline: "Bright, even print on non woven carry bags.",
    description:
      "Inks for printing non woven polypropylene fabric used for D-cut, W-cut, loop handle and box bags. Smooth flow on the open fabric texture gives clean, bright prints that stay on the bag through everyday use.",
    applications: ["Non woven carry bags (D-cut, W-cut, loop handle)", "Shopping & promotional bags", "Non woven PP fabric rolls"],
    features: ["Good adhesion on non woven PP", "Bright, even colour", "Suited to flexo & screen printing"],
  },
  {
    slug: "food-grade-fibc-ink",
    name: "Food Grade Inks for FIBC Bags",
    short: "Food Grade FIBC Ink",
    category: "Specialty Packaging",
    isNew: true,
    swatch: "#FF5A00",
    image: "/img/new-fibc.jpg",
    tagline: "Clean print for the jumbo bags that carry food.",
    description:
      "A food-grade ink system for printing FIBC (jumbo) bags that carry food ingredients, grains and other edible bulk material. Built for woven polypropylene fabric, with sharp, steady colour from the first bag to the last.",
    applications: ["FIBC / jumbo bulk bags", "Food ingredient packaging", "Grain & flour bulk bags"],
    features: ["Food grade formulation", "Made for woven PP fabric", "Steady shade batch to batch"],
  },
  {
    slug: "heat-resistant-cement-bag-ink",
    name: "Heat Resistant Inks for Cement Bags",
    short: "Heat Resistant Cement Ink",
    category: "Specialty Packaging",
    isNew: true,
    swatch: "#FFC400",
    image: "/img/im-valvebag.jpg",
    tagline: "Print that holds through hot filling and sealing.",
    description:
      "Heat resistant inks for cement bags, including block-bottom valve bags. The print keeps its colour and sharpness through heat sealing and hot product filling on the packing line.",
    applications: ["Cement bags", "Block-bottom valve bags", "Woven PP sacks for building materials"],
    features: ["Heat resistant", "Strong colour on woven PP", "Suited to heat sealing"],
  },
  {
    slug: "tape-tested-fertilizer-bag-ink",
    name: "Tape Tested Inks for Fertilizer Bags",
    short: "Tape Tested Fertilizer Ink",
    category: "Specialty Packaging",
    isNew: true,
    swatch: "#2F7D32",
    image: "/img/new-fertilizer.jpg",
    tagline: "Adhesion that passes the tape test.",
    description:
      "Tape tested inks for fertilizer bags. Strong adhesion keeps the print on the bag through stacking, transport and handling, so the brand and product details stay readable.",
    applications: ["Fertilizer bags", "Agro-chemical sacks", "Woven & laminated PP bags"],
    features: ["Tape tested adhesion", "Rub resistant print", "Bright, bold colours"],
  },
  {
    slug: "metallic-ink",
    name: "Metallic Ink",
    short: "Metallic Ink",
    category: "Surface Printing",
    swatch: "#B8A06A",
    image: "/img/tide-foil.jpg",
    tagline: "Gold, silver and bronze finishes for poly.",
    description:
      "Metallic inks for poly films that give packaging a gold, silver or bronze shine. Made from carefully chosen resins, pigments and solvents for a smooth, even metallic finish.",
    applications: ["Poly bags & films", "Premium consumer packaging", "Decorative print"],
    features: ["Bright metallic lustre", "Even laydown", "Made for poly substrates"],
  },
  {
    slug: "reverse-lamination-ink",
    name: "Reverse Lamination Ink",
    short: "Reverse Lamination Ink",
    category: "Lamination",
    swatch: "#E23A1F",
    image: "/img/im-bopp-ext.jpg",
    tagline: "Printed on the back, sealed behind the film.",
    description:
      "Inks for reverse printing on films that are then laminated. The print sits safely between layers, giving bright, glossy graphics on flexible packaging.",
    applications: ["Flexible laminated pouches", "Snack & food packaging", "Multilayer films"],
    features: ["Good lamination bond", "High gloss", "Bright colour"],
  },
  {
    slug: "extrusion-lamination-ink",
    name: "Extrusion Lamination Ink",
    short: "Extrusion Lamination Ink",
    category: "Lamination",
    swatch: "#1E88E5",
    image: "/img/im-bopp.jpg",
    tagline: "Built for the extrusion laminator.",
    description:
      "Extrusion lamination inks for BOPP and other films. They hold their colour and bond under the heat and pressure of the extrusion lamination process.",
    applications: ["BOPP laminated bags", "Woven sack lamination", "Flexible packaging"],
    features: ["Strong bond in extrusion", "Holds colour under heat", "Made for BOPP"],
  },
  {
    slug: "foil-ink",
    name: "Foil Ink",
    short: "Foil Ink",
    category: "Specialty Packaging",
    swatch: "#9E9E9E",
    image: "/img/im-foil.jpg",
    tagline: "For confectionery foils and wraps.",
    description:
      "Foil inks for printing aluminium foil used in confectionery and food wraps. Clean, sharp print that stays on the foil.",
    applications: ["Confectionery wrappers", "Aluminium foil packaging", "Food wraps"],
    features: ["Good adhesion on foil", "Sharp detail", "Bright shades"],
  },
  {
    slug: "gravure-ink",
    name: "Gravure Ink",
    short: "Gravure Ink",
    category: "Surface Printing",
    swatch: "#7B1FA2",
    image: "/img/im-flexo.jpg",
    tagline: "Fine detail at rotogravure speed.",
    description:
      "Gravure inks for rotogravure printing on films and packaging. Smooth flow and fine detail for high-volume press runs.",
    applications: ["Rotogravure film printing", "Flexible packaging", "Labels & wrappers"],
    features: ["Smooth press flow", "Fine detail", "Consistent shade"],
  },
  {
    slug: "poly-ink",
    name: "Poly Ink",
    short: "Poly Ink",
    category: "Surface Printing",
    swatch: "#00897B",
    image: "/img/tide-poly.jpg",
    tagline: "Everyday print for poly bags.",
    description:
      "Poly inks for printing polyethylene bags and films such as HM, LDPE and LLDPE. A dependable ink for carry bags and everyday packaging.",
    applications: ["Carry bags", "LDPE / HM bags", "Poly films"],
    features: ["Good adhesion on PE", "Quick drying", "Wide shade range"],
  },
  {
    slug: "woven-sack-ink",
    name: "Woven Sack Ink",
    short: "Woven Sack Ink",
    category: "Surface Printing",
    swatch: "#1565C0",
    image: "/img/tide-woven.jpg",
    tagline: "Bold print on woven PP and HDPE sacks.",
    description:
      "Woven sack inks for HDPE and PP woven bags used for flour, sugar, grain and more. Bold colours that stay readable on the woven texture.",
    applications: ["Flour & sugar sacks", "Grain bags", "HDPE / PP woven fabric"],
    features: ["Bold colour on woven fabric", "Good rub resistance", "Made for flexo printing"],
  },
  {
    slug: "ink-reducer",
    name: "Ink Reducer",
    short: "Ink Reducer",
    category: "Auxiliaries",
    swatch: "#0B0B0B",
    image: "/img/tide-reducer.jpg",
    tagline: "Keeps every ink at the right viscosity.",
    description:
      "Ink reducer to adjust the viscosity of printing inks on the press, so the ink keeps flowing and printing evenly through the run.",
    applications: ["Gravure & flexo presses", "Viscosity correction", "Press-side ink adjustment"],
    features: ["Matched to our ink range", "Easy press-side use", "Supplied in bulk"],
  },
];

export const PRODUCTS = [...RAW_PRODUCTS].sort((a, b) => PRODUCT_ORDER.indexOf(a.slug) - PRODUCT_ORDER.indexOf(b.slug));
